<template>
    <div id="secondComponent">
        <input type="checkbox" id="jack" value="Jack" v-model="checkedNames">
        <label for="jack">Jack</label>
        <input type="checkbox" id="john" value="John" v-model="checkedNames">
        <label for="john">John</label>
        <input type="checkbox" id="mike" value="Mike" v-model="checkedNames">
        <label for="mike">Mike</label>
        <br>
        <span>Checked names: {{ checkedNames }}</span>
        <!-- computed 计算属性  -->
        <div>
            <h2>All Tasks</h2>
            <ul>
                <li v-for="task in tasks" v-text='task.description'></li>
            </ul>
            <h2>inncompleted Tasks</h2>
            <ul>
                <li v-for="task in inncompletedTasks" v-text='task.description'></li>
            </ul>
        </div>
    </div>

</template>

<script>
export default {
    data () {
        return {
          author: 'cloudImages',
          checkedNames:[],
          firstName:'G',
          lastName:'Jx',
          tasks:[ {description:'Go to the shop',completed:false},
                  {description:'Fucker more',completed:true},
                  {description:'Buy a video',completed:false},
                  {description:'Watch a movie',completed:true},
                  {description:'Take a walk',completed:false},
              ]
        }
    },
    computed: {
        inncompletedTasks(){
            return this.tasks.filter(task=>!task.completed);
        }
    },
    watch: {
        '$route' (to, from) {
          console.log(to)
        }
    }
}
</script>



// WEBPACK FOOTER //
// secondComponent.vue?6ce02f90